import Vue from 'vue';
import Vuei18n from 'vue-i18n';
import nlBe from './locales/nlBe.json';
import frFr from './locales/frFr.json';
import enGb from './locales/enGb.json';

Vue.use(Vuei18n);

const i18n = new Vuei18n({
  locale: 'nl',
  fallbackLocale: 'nl',
  messages: {
    nl: nlBe,
    fr: frFr,
    en: enGb,
  },
});

export default i18n;
